import * as angular from 'angular';

export const SlideDeckInstructionsController = angular.noop;
